import { render, staticRenderFns } from "./ResponsiveTable.vue?vue&type=template&id=f5e34d8e"
import script from "./ResponsiveTable.vue?vue&type=script&lang=js"
export * from "./ResponsiveTable.vue?vue&type=script&lang=js"
import style0 from "./ResponsiveTable.vue?vue&type=style&index=0&id=f5e34d8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports